export default {
    PrintElement(id) {
        let printer = window.open('', 'PRINT');

        printer.document.write('<html><head>');
        _(document.getElementsByTagName('style')).each(t => {
            printer.document.write(t.outerHTML);
        });
        _(document.getElementsByTagName('link')).each(t => {
            printer.document.write(t.outerHTML);
        });

        printer.document.write(`<style>.report-container { margin: 20px; }</style>`);
        printer.document.write('</head><body>');

        const element = document.getElementById(id);

        if (element && element.innerHTML) {
            printer.document.write(element.innerHTML);
        }

        printer.document.write('</body></html>');
        printer.document.close(); // necessary for IE >= 10
        setTimeout(() => {
            printer.focus(); // necessary for IE >= 10*/
            printer.print();
            printer.close();
        }, 100);
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/utils/Printing.jsx